import type { ReactNode } from 'react'

import { useAuth } from '@/hooks/useAuth'

import { CampLoader } from './CampLoader'

export function AuthGate({ children }: { children: ReactNode }) {
  const { isLoading } = useAuth()

  if (isLoading) {
    return <CampLoader />
  }

  return <>{children}</>
}
